import React from 'react';
import LoadingStatus from '@/components/ui/LoadingStatus';

const Wrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="bg-white dark:bg-gray-900 rounded-lg shadow p-6 mt-6">
    <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">Player Statistics</h3>
    {children}
  </div>
);

export const LoadingPanel: React.FC = () => (
  <Wrapper>
    <LoadingStatus label="Loading match player statistics" className="h-32 justify-center" />
  </Wrapper>
);

export const ErrorPanel: React.FC<{ error: string }> = ({ error }) => (
  <Wrapper>
    <div className="p-4 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg">
      <p className="text-red-800 dark:text-red-300">{error}</p>
    </div>
  </Wrapper>
);

export const EmptyPanel: React.FC = () => (
  <Wrapper>
    <p className="text-gray-500 dark:text-gray-400">No player statistics available for this match.</p>
  </Wrapper>
);
